import React from 'react';

import { InfoCard } from '@eika/card';
import { Link } from '@eika/link';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import { useConfig } from '../../defaultConfig';
import useTranslation from '../../hooks/useTranslation';

const EFakturaEmptyList: React.FC = () => {
    const translated = useTranslation();
    const { frontPageLink } = useConfig();

    return (
        <InfoCard className="eFaktura-empty-list">
            <RichIcon type={RichIconTypes.SPOKELSE} />
            <InfoCard.TitleH3>{translated.eFakturaEmpty.title}</InfoCard.TitleH3>
            <p className="eFaktura-empty-list__description">{translated.eFakturaEmpty.description}</p>
            {frontPageLink?.url && (
                <Link href={frontPageLink.url} size="small" linkType="button-positive">
                    {translated.eFakturaEmpty.link}
                </Link>
            )}
        </InfoCard>
    );
};

export default EFakturaEmptyList;
